import React from 'react';
import './blog-post.css';
import './blog-slides.css';
import attendees from './pictures/researchFireside.jpeg';

const ResearchFireside = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header></header>
                <section>
                    <h2>Fireside Chat with Professor Taylor Faulkner</h2>
                    <p className="site-post-meta">February 2, 2026</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>
                    Thank you for joining us for our Fireside Chat with Professor Taylor Faulkner! She shared her insights on AI/research and the changing landscape of education and industry during our event on Monday 👩‍💻📚! We loved having all of you and hope you enjoyed the many snacks and hearing from Professor Taylor Faulkner.
                    <br></br>
                    We hope everyone enjoyed the fireside chat. Big thank you to Professor Faulkner for her time and sharing so much about her work!
                    <br></br>
                    <br></br>
                    </p>
                    <img src={attendees} alt="Attendees at the event."/>
                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default ResearchFireside;